module.exports = __webpack_public_path__ + "img/IMG-20220420-WA0000.97e935c2.jpg";